import { z } from 'zod';

export enum MessageLabel {
  QUOTE_NEEDS_REVIEW = 'Quote Needs Review',
  QUOTE_DRAFTED = 'Quote Drafted',
  QUOTE_SENT = 'Quote Sent',
  QUOTE_WON = 'Quote Won',
}

export const EmailTagEnum = z.enum([
  MessageLabel.QUOTE_NEEDS_REVIEW,
  MessageLabel.QUOTE_DRAFTED,
  MessageLabel.QUOTE_SENT,
  MessageLabel.QUOTE_WON,
]);

export const EmailTagSettingsSchema = z.object({
  enabledTags: z
    .array(EmailTagEnum)
    .optional()
    .nullable()
    .describe('List of email tags to actively label'),
});

export type EmailTagSettings = z.infer<typeof EmailTagSettingsSchema>;
